import {
  Button,
  Form,
  Input,
  Select,
  Typography,
  message
} from 'antd';
import type { ForwardRefRenderFunction } from 'react';
import { forwardRef, memo, useEffect, useImperativeHandle, useState } from 'react';

import { tryit } from 'radash';
import type { BaseFormExposeRef, BaseFormProps } from '../../../types';
import type { ExtractionRangeEnum } from '../types';
import { extractionRangeOptions } from './const';
import { RuleAndFieldGroupItem } from './rule-and-field-group-item';
import type { SemanticFormType } from './semantic-form-item';

export interface FormType {
  extraction_range: keyof typeof ExtractionRangeEnum;
  pages: string;
  ignore_headers: boolean;
  rules: (SemanticFormType | null)[];
}

export type SemanticFormProps = BaseFormProps<FormType>;

export interface ReturnType {
  form: FormType;
}

const PanelForm: ForwardRefRenderFunction<
  BaseFormExposeRef<ReturnType>,
  SemanticFormProps
> = ({ initialValue, readonly, node_id }, ref) => {
  const [form] = Form.useForm<FormType>();

  // const { nodesReadOnly: readonly } = useWorkflowReadOnly();
const [activeField, setActiveField] = useState<number>();
  useImperativeHandle(ref, () => ({
    assembleForm: async () => {
      const [err, values] = await tryit(form.validateFields)();
      if (err) return;

      // message.success('验证成功');
      return {
        form: values,
      };
    },
  }));

  useEffect(() => {
    form.setFieldsValue(
      initialValue || {
        extraction_range: 'ALL',
        rules: [null],
      },
    );
  }, [initialValue, form]);

  return (
    <div className="px-6">
      <div className="flex justify-center items-center w-full">
        <Form
          disabled={readonly}
          layout="vertical"
          form={form}
          name="semantic-form"
          className="w-full"
          autoComplete="off"
          // initialValues={initialValue}
        >
          <div className="flex items-end gap-4">
            <Form.Item<FormType>
              label="抽取范围"
              name="extraction_range"
              className="basis-1/3"
            >
              <Select
                getPopupContainer={(el) => el.parentElement}
                placeholder="请选择抽取范围"
                options={extractionRangeOptions}
              />
            </Form.Item>

            <Form.Item noStyle shouldUpdate={() => true}>
              {(form) => {
                const range: FormType['extraction_range'] =
                  form.getFieldValue('extraction_range');
                if (range !== 'TARGET') return null;
                return (
                  <Form.Item<FormType>
                    name="pages"
                    label=""
                    className="basis-2/3"
                    rules={[
                      {
                        pattern: /^((\d+)|(\d+);|(\d+)-(\d+);?)+$/,
                        message: '请输入正确的格式如 1;3-5;7',
                        warningOnly: true,
                      },
                    ]}
                  >
                    <Input placeholder="请输入页号如 1;3-5;7" maxLength={32} />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </div>
          {/* <Form.Item<FormType>
            label="忽略页眉页脚"
            valuePropName="checked"
            name="ignore_headers"
          >
            <Checkbox>忽略页眉页脚</Checkbox>
          </Form.Item> */}

          <Form.List name="rules">
            {(fields, operations, meta) => (
              <>
                {fields.map((field) => (
                  <RuleAndFieldGroupItem
                    node_id={node_id}
                    prefix={['rules', field.name]}
                    field={field}
                    operations={operations}
                    key={field.key}
                    activeField={activeField ?? 0}
                    setActiveField={setActiveField}
                    readonly={readonly}
                    onDelete={(fileName) => {
                      if (readonly) return;
                      if (fields.length === 1) {
                        message.warning('至少保留一个字段或规则');
                        return;
                      }

                      operations.remove(fileName);
                    }}
                  />
                ))}
                <Button type="dashed" onClick={() => operations.add()} block>
                  + 添加字段和规则
                </Button>
              </>
            )}
          </Form.List>

          {/* <Form.Item noStyle shouldUpdate>
            {() => (
              <Typography>
                <pre>{JSON.stringify(form.getFieldsValue(), null, 2)}</pre>
              </Typography>
            )}
          </Form.Item> */}
        </Form>
      </div>
    </div>
  );
};

export default memo(forwardRef(PanelForm));
